import { render } from "./AppFooter.vue?vue&type=template&id=5f6e1205"
const script = {}

import exportComponent from "C:\\Users\\Song\\Documents\\Fun\\snapshot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__